export default __webpack_public_path__ + "static/media/digital-agency-contact-image-02.7ab814b2.jpg";